import { useQuery } from "@tanstack/react-query";
import { Text } from "../atoms";
import React from "react";
async function initialize() {
  const {
    setLanguagePersistToState,
    setThemePersistToState,
    setAccessTokenPersistToState,
  } = await import("./storeProviders");
  try {
    const fetch = [
      setLanguagePersistToState(),
      setThemePersistToState(),
      setAccessTokenPersistToState(),
    ];
    await Promise.all(fetch);
    return true;
  } catch (e) {
    return false;
  }
}
const Initialize = ({ children }: { children: () => JSX.Element | null }) => {
  const { data: isInitialized } = useQuery({
    queryKey: ["initialize"],
    queryFn: initialize,
  });

  console.log({ isInitialized }, Boolean(isInitialized));

  return Boolean(isInitialized) ? children() : null;
};

export default Initialize;
